import { render, staticRenderFns } from "./afterSaleCopy.vue?vue&type=template&id=a7868a20&scoped=true"
import script from "./afterSaleCopy.vue?vue&type=script&lang=js"
export * from "./afterSaleCopy.vue?vue&type=script&lang=js"
import style0 from "./afterSaleCopy.vue?vue&type=style&index=0&id=a7868a20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7868a20",
  null
  
)

export default component.exports